// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import iView from 'view-design'
// import 'view-design/dist/styles/iview.css';
import '../iviewtheme/index.less'
import App from './App'
import router from './router'
import './components/index' // 全局自定义组件
import * as filters from './filters' // 全局过滤器
import store from './store'
import * as apiPort from './api/api'
import { Spin } from 'view-design'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import addressParser from '../static/zh_address_parse.min.js'

// import VueTinymce from "@packy-tang/vue-tinymce"
// Vue.use(VueTinymce)

window._AMapSecurityConfig = {
    securityJsCode: '476581fe3bf41a803ca78a933555d570',
}

import VueAMap from 'vue-amap'
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
    key: '954a65e42969f3509de009bbda4f9a49',
    plugin: ['AMap.Geocoder'],
})
Vue.prototype.VueAMap = VueAMap
Vue.prototype.apiPort = apiPort

Vue.config.productionTip = false
Vue.use(iView)
Vue.use(VXETable)

// register global utility filters.
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key])
})

Vue.prototype.$tableScroll = (table) => {
    table.$refs.body.scrollTop = 0
    table.$refs.body.scrollLeft = 0
}

import axios from 'axios'
let queue = []
let currentRequests = [] // 存储当前正在进行的请求

const whitelist = ['/web/session/load', '/web/session/badge/load', '/web/main/zhanghaos/load', '/web/psgh/pssqsh/querypay', '/web/psyh/pssqd/querypay', '/web/main/chaxunyue']

function destroy(requesturl) {
    if (
        !requesturl ||
        !whitelist.some((url) => {
            return requesturl.includes(url)
        })
    ) {
        queue.pop() // 弹出遵循先进先出原则
    }
    setTimeout(() => {
        // 延迟100ms看看是否是否有嵌套接口
        if (!queue.length) {
            // 如果队列里还有没有完成的请求就不关闭loading效果
            Spin.hide()
            //这里解决有滚动条的同一页面切换账号后就没有滚动条了
            if (document.getElementsByClassName('ivu-modal-wrap').length == document.getElementsByClassName('ivu-modal-hidden').length) {
                document.getElementsByTagName('body')[0].style = {}
            }
        }
    }, 100)
}

// 取消所有请求的函数
function cancelAllRequests() {
    // 取消所有正在进行的请求
    currentRequests.forEach(request => {
        if (request.cancelSource) {
            request.cancelSource.cancel('用户取消请求')
        }
    })
    // 清空队列和请求数组
    queue = []
    currentRequests = []
    // 隐藏loading
    Spin.hide()
    // 显示取消提示
    iView.Message.info({
        content: '已取消所有请求',
        duration: 2
    })
}

axios.interceptors.request.use(function(request) {
    console.log('[req] ' + request.url + '\n', request.data)

    if (store.auto_update && request.url.indexOf('/list') > -1 && request.url.indexOf('/gengxinrizhi/list') == -1) {
        sessionStorage.updateTip = true
        window.location.reload()
        //cancel request
        return Promise.reject('cancel request')
    }

    // 为每个请求添加cancelToken
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()
    request.cancelToken = source.token
    request.cancelSource = source

    if (!(request.data && request.data._hideLoading) && !whitelist.some((url) => request.url.includes(url))) {
        queue.unshift(request.url)
        currentRequests.push(request)
    }

    if (queue.length) {
        // 检查是否有需要显示取消按钮的接口
        const hasCancelableRequests = currentRequests.some(req =>
            // req.url.endsWith('/list') || req.url.endsWith('/load')
            req.url.indexOf('/list') > -1
        )

        // 如果队列中有值就打开loading
        Spin.show({
            render: (h) => {
                const loadingElements = [
                    h('div', {
                        class: 'loading-content'
                    }, [
                        h('Icon', {
                            class: 'spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                size: 30,
                            },
                        }),
                        h('div', {
                            class: 'loading-text'
                        }, '加载中...')
                    ])
                ]

                // 只有在有可取消的请求时才显示取消按钮
                if (hasCancelableRequests) {
                    loadingElements.push(
                        h('div', {
                            class: 'loading-cancel-btn',
                            on: {
                                click: cancelAllRequests
                            }
                        }, '取消')
                    )
                }

                return h('div', {
                    class: 'loading-container'
                }, [
                    h('div', {
                        class: 'loading-card'
                    }, loadingElements)
                ])
            },
        })
    }
    return request
})

function fixfloat(obj) {
    if (obj === null || obj === undefined) {
        return obj
    }
    if (typeof obj === 'number') {
        return NumberFix(obj, 10)
    }
    if (typeof obj === 'string') {
        return obj
    }
    if (Array.isArray(obj)) {
        for (let i = 0; i < obj.length; i++) {
            obj[i] = fixfloat(obj[i])
        }
    } else {
        for (let key in obj) {
            if (Array.isArray(obj[key])) {
                for (let i = 0; i < obj[key].length; i++) {
                    obj[key][i] = fixfloat(obj[key][i])
                }
            } else {
                obj[key] = fixfloat(obj[key])
            }
        }
    }
    return obj
}

axios.defaults.headers.common['v'] = 2

axios.interceptors.response.use(
    function(response) {
        destroy(response.request.responseURL)
        // 从currentRequests中移除已完成的请求
        const requestIndex = currentRequests.findIndex(req => req === response.config)
        if (requestIndex > -1) {
            currentRequests.splice(requestIndex, 1)
        }
        console.log('[res] ' + response.config.url + '\n', Vue.prototype.copy(response.data))
        if (response.data.session) {
            //session被更新时会返回
            updateSession(response.data.session)
            vue.$refs['app'].sessionChanged(response.data.session)
        }
        if (response.data.badge && vue.$refs['app'].session && vue.$refs['app'].session.badge) {
            vue.$refs['app'].session.badge = response.data.badge
        }

        if (response.data.code == 1) {
            iView.Message.error({
                content: response.data.error,
                duration: 2,
                closable: true
            })
        }
        if (response.data) {
            // let start = new Date().getTime()
            fixfloat(response.data)
            // let end = new Date().getTime()
            // console.log('fixfloat took ' + (end - start) + ' ms')
        }
        return response
    },
    function(error) {
        destroy(error.config ? error.config.url : null)
        // 处理请求被取消的情况
        if (axios.isCancel(error)) {
            console.log('请求被取消:', error.message)
            // 从currentRequests中移除已取消的请求
            const requestIndex = currentRequests.findIndex(req => req === error.config)
            if (requestIndex > -1) {
                currentRequests.splice(requestIndex, 1)
            }
            return Promise.reject(error)
        }
        if (!error.response) {
            console.log('system error', error)
            return { data: { error: '网络异常，请稍后再试' } }
        }
        if (error.response.status == 502) {
            return { data: { error: '系统升级，请稍后重试', status: 502 } }
        } else if (error.response.status == 500) {
            if (error.response.data && error.response.data.title) { //非prod环境会返回具体异常信息
                let e = error.response.data
                if (e.msg == `Cannot read property 'collection' of null`) {
                    iView.Message.warning('系统忙，请重试')
                } else {
                    iView.Message.warning({
                        closable: true,
                        background: true,
                        duration: 8,
                        render: h => {
                            return h('div', {
                                style: {
                                    'text-align': 'left',
                                }
                            }, [
                                h('div', {
                                    style: {
                                        'font-weight': 'bold',
                                        'color': 'red',
                                        'font-size': '20px',
                                    }
                                }, e.title),
                                h('div', {
                                    style: {
                                        'color': '#333',
                                    }
                                }, e.url ? (e.url + e.info) : '请联系服务商，建议提供当前截图以便定位问题'),
                                h('p', {
                                    style: {
                                        'white-space': 'pre-wrap',
                                        'font-weight': 'bold',
                                    }
                                }, e.msg),
                            ])
                        }
                    })
                }
            }
            return { data: { error: error.response.data, status: error.response.status } }
        } else if (error.response.status == 401) {
            return (window.location.hash = '/logout')
        } else if (error.response.status == 409) {
            iView.Message.error({
                content: '会话已更新，即将刷新页面，请重试',
                duration: 4,
                closable: true,
            })
            setTimeout(() => {
                window.location.reload()
            }, 2000)
        } else if (error.response.status == 403) {
            iView.Message.error({
                content: '无此操作权限，请重新登录',
                duration: 4,
                closable: true,
            })
        } else if (error.response.status == 413) {
            iView.Message.error({
                content: '一次操作的数据太多啦，请减少数据量再试',
                duration: 4,
                closable: true,
            })
        } else if (error.response.status == 400) {
            iView.Message.error({
                content: error.response.data,
                duration: 4,
                closable: true,
            })
        } else if (error.response.status == 404) {
            iView.Message.error({
                content: '页面不存在，请刷新后再试',
                duration: 4,
                closable: true,
            })
        } else {
            iView.Message.error({
                content: '系统错误，请联系服务商',
                duration: 4,
                closable: true
            })
        }
        return error.response
    })

let api = {
    get: async function(url) {
        let res = await axios.get('/g/api' + url)
        if (res.data.status == 502) {
            //wait 1s retry
            await new Promise((resolve) => setTimeout(resolve, 1000))
            return await api.get(url)
        } else {
            return res
        }
    },
    post: async function(url, data) {
        let res = await axios.post('/g/api' + url, data)
        if (res.data.status == 502) {
            //wait 1s retry
            await new Promise((resolve) => setTimeout(resolve, 1000))
            return await api.post(url, data)
        } else {
            return res
        }
    },
    uploadFile: async function(file, token) {
        const url = window.location.protocol + '//upload.qiniup.com'
        const formData = new FormData()
        formData.append('file', file)
        formData.append('token', token)
        return await axios.post(url, formData)
    },
}

Vue.prototype.$http = axios
Vue.prototype.$api = api
Vue.prototype.loadSession = async function({ changes, dataChanged, badgeChanged, cb }) {
    if (!store.session) {
        let stored_token = sessionStorage.token
        if (stored_token) axios.defaults.headers.common['token'] = stored_token
        let stored_timestamp = sessionStorage.timestamp
        if (stored_timestamp) axios.defaults.headers.common['timestamp'] = stored_timestamp
    }
    let res = await api.post('/web/session/load', {
        dataChanged,
        badgeChanged,
        changes,
    })
    // updateSession(res.data.session)
    if (res.data.error) {
        if (res.data.error == '机构不可用') {
            return (window.location.hash = '/logout')
        }
    }
    let session = res.data.session
    updateSession(session)
    if (cb) cb(session)
}

Vue.prototype.loadBadge = async function(cb) {
    let res = await api.post('/web/session/badge/load', {})
    store.session.badge = res.data.badge
    if (cb) cb(res.data)
    return res.data
}

Vue.prototype.hasPermission = function(groupname, menuname, buttonname) {
    let group = store.session.menuGroups.findOne({ name: groupname })
    if (group && group.menus) {
        let menu = group.menus.findOne({ name: menuname })
        if (menu) {
            if (buttonname && menu.buttons) {
                let button = menu.buttons.findOne({ name: buttonname })
                if (button && button.actived) return true
            } else {
                return true
            }
        }
    }
    return false
}

Vue.prototype.hasPermissionKey = function(groupcode, menucode, buttonkey) {
    let group = store.session.menuGroups.findOne({ code: groupcode })
    if (group && group.menus) {
        let menu = group.menus.findOne({ code: menucode })
        if (menu) {
            if (buttonkey && menu.buttons) {
                let button = menu.buttons.findOne({ key: buttonkey })
                if (button && button.actived) return true
            } else {
                return true
            }
        }
    }
    return false
}

iView.Modal.props.maskClosable.default = false

function updateSession(session) {
    if (session.zhanghao && session.zhanghao.jigou && session.zhanghao.jigou.actived === false) {
        iView.Message.error(session.zhanghao.jigou.name + '已暂停使用供应链')
        return (window.location.hash = '/logout')
    }
    if (session.zhanghao && session.zhanghao.jituan && session.zhanghao.jituan.actived === false) {
        iView.Message.error(session.zhanghao.jituan.name + '已暂停使用供应链')
        return (window.location.hash = '/logout')
    }
    if (session.zhanghao && (session.zhanghao.deleted || !session.zhanghao.actived)) {
        iView.Message.error('账号已失效，请重新登陆')
        return (window.location.hash = '/logout')
    }
    if (session.permissions) {
        session.permission = {}
        for (let item of session.permissions) {
            if (item.checked) {
                session.permission[item.key] = true
            }
        }
    }
    store.session = session
    if (session.token) axios.defaults.headers.common['token'] = session.token
    axios.defaults.headers.common['timestamp'] = session.timestamp
    sessionStorage.token = session.token
    sessionStorage.timestamp = session.timestamp
}

Vue.prototype.copy = function(obj) {
    if (!obj) {
        return obj
    }
    if (typeof obj != 'object') {
        return obj
    }
    return JSON.parse(JSON.stringify(obj))
}

Vue.prototype.logout = function() {
    store.session = null
    axios.defaults.headers.common['token'] = null
    axios.defaults.headers.common['timestamp'] = null
}

Vue.prototype.getAllChildren = function(node) {
    let nodes = []
    getChildren(nodes, node)
    return nodes
}

Number.prototype.toFixed = function(fix) {
    return NumberFix(this, fix)
}

function getChildren(nodes, node, visited = new Set()) {
    if (visited.has(node)) {
        return
    }
    visited.add(node)

    if (node.children && node.children.length) {
        for (let item of node.children) {
            getChildren(nodes, item, visited)
        }
    } else {
        nodes.push(node)
    }
}

initChinapcData()

async function initChinapcData() {
    let res = await api.post('/web/main/chinapc/load')
    const chinapcdata = res.data
    let extraGovData = {
        province: [],
        city: [],
        area: [],
    }
    Vue.prototype.$chinapcdata = chinapcdata
    chinapcdata.forEach((province) => {
        extraGovData.province.push({
            code: province.code,
            name: province.name,
        })
        province.children.forEach((city) => {
            extraGovData.city.push({
                code: city.code,
                name: city.name,
                provinceCode: province.code,
            })
            if (city.children) {
                city.children.forEach((area) => {
                    extraGovData.area.push({
                        code: area.code,
                        name: area.name,
                        cityCode: city.code,
                        provinceCode: province.code,
                    })
                })
            }
        })
    })
    Vue.prototype.$parseAddress = function(address) {
        return addressParser(address, {
            type: 1,
            extraGovData,
        })
    }
}

var qiniu = {
    token: null,
}

Vue.prototype.loadCangkuwupins = async function(body, cb) {
    let res = await this.$api.post('/web/main/cangkuwupins/load', {
        cangkuId: body.cangku ? body.cangku._id : undefined,
        riqi: body.riqi,
        // codes: body.wupins.map(item => { return item.code }),
        wupins: body.wupins.map((item) => {
            return { code: item.code, huozhu: item.huozhu }
        }),
        pandian: body.pandian,
    })
    let cangkuwupins = res.data.cangkuwupins
    for (let item of body.wupins) {
        let cangkuwupin = cangkuwupins.find((o) => o.wupin.code == item.code && ((!o.huozhu && !item.huozhu) || (o.huozhu && item.huozhu && o.huozhu._id == item.huozhu._id)))
        if (cangkuwupin) {
            item.xiancunshuliang = cangkuwupin.wupin.xiancunshuliang
            item.jine = cangkuwupin.wupin.jine
            if (item.xiancunshuliang > 0 || item.xiancunshuliang < 0) {
                item.kucunjunjia = item.jine / item.xiancunshuliang
            } else if (cangkuwupin.wupin.zuijinkucunjunjia !== undefined) {
                item.zuijinkucunjunjia = cangkuwupin.wupin.zuijinkucunjunjia
                item.kucunjunjia = cangkuwupin.wupin.zuijinkucunjunjia
            } else {
                item.kucunjunjia = cangkuwupin.wupin.cankaochengben || 0
            }
            if (body.type === 'qimochengbentiaozheng') {
                item.zhangmianshuliang = cangkuwupin.wupin.zhangmianshuliang
                item.zhangmianjine = cangkuwupin.wupin.zhangmianjine
                item.tiaozhenghoujine = cangkuwupin.wupin.tiaozhenghoujine
                item.tiaozhengjine = cangkuwupin.wupin.tiaozhengjine
            }
        } else {
            item.xiancunshuliang = 0
            item.jine = 0
            item.kucunjunjia = item.kucunjunjia || item.cankaochengben
            if (body.type === 'qimochengbentiaozheng') {
                item.zhangmianshuliang = 0
            }
        }
    }
    if (cb) cb(cangkuwupins)
    return cangkuwupins
}

Vue.prototype.loadUploadToken = function(cb) {
    if (qiniu.token && new Date(qiniu.token.expiryTime) > new Date()) {
        return cb(qiniu.token.value)
    } else {
        this.$api.get('/qiniu/token').then((response) => {
            qiniu.token = response.data
            return cb(qiniu.token.value)
        })
    }
}

import moment from 'moment'
Vue.prototype.moment = moment
moment.locale('zh-cn')

//类似mongo的findOne
function checkKeyValue(value, item, object, field, longkey) {
    if ((object === undefined || object === null) && value !== undefined && value !== null) {
        return false
    }
    if (field.indexOf('.') != -1 && !longkey) {
        let r = checkKeyValue(value, item, object, field, true)
        if (r) return r
        let objectname = field.substring(0, field.indexOf('.'))
        let newField = field.substring(field.indexOf('.') + 1, field.length)
        let newObject = object[objectname]
        return checkKeyValue(value, item, newObject, newField)
    }
    if (value instanceof Array && field == '$or') {
        let ormatched = false
        for (let oritem of value) {
            let orkeymatched = 0
            for (let orkey of Object.keys(oritem)) {
                let r = checkKeyValue(oritem[orkey], item, object, orkey)
                if (r) orkeymatched++
            }
            if (orkeymatched == Object.keys(oritem).length) {
                ormatched = true
            }
        }
        return ormatched
    }
    if (value instanceof Array && field == '$and') {
        for (let oritem of value) {
            for (let orkey of Object.keys(oritem)) {
                let r = checkKeyValue(oritem[orkey], item, object, orkey)
                if (!r) return false
            }
        }
        return true
    }
    if (typeof value == 'object' && value !== null && value['$in'] !== undefined) {
        let invalue = value['$in']
        return invalue.indexOf(object[field]) != -1
    }
    if (typeof value == 'object' && value !== null && value['$nin'] !== undefined) {
        let ninvalue = value['$nin']
        return ninvalue.indexOf(object[field]) == -1
    }
    if (typeof value == 'object' && value !== null && value['$ne'] !== undefined) {
        let nevalue = value['$ne']
        if (object && nevalue && object[field] === nevalue) return false
        if (object && nevalue === null && (object[field] === null || object[field] === undefined)) return false
        return true
    }
    if (object && object[field] === undefined && value === undefined) return true
    let result = object && object[field] === value ? true : false
    return result
}

Array.prototype.findOne = function(query) {
    for (let item of this) {
        let matched = {}
        for (let key of Object.keys(query)) {
            let r = checkKeyValue(query[key], item, item, key)
            if (r) matched[key] = true
        }
        if (Object.keys(matched).length == Object.keys(query).length) {
            return item
        }
    }
    return null
}

Array.prototype.findAll = function(query) {
    let result = []
    for (let item of this) {
        let matched = {}
        for (let key of Object.keys(query)) {
            let r = checkKeyValue(query[key], item, item, key)
            if (r) matched[key] = true
        }
        if (Object.keys(matched).length == Object.keys(query).length) {
            result.push(item)
        }
    }
    return result
}

Array.prototype.remove = function(query) {
    let result = []
    for (let i = this.length - 1; i >= 0; i--) {
        let item = this[i]
        let matched = {}
        for (let key of Object.keys(query)) {
            let r = checkKeyValue(query[key], item, item, key)
            if (r) matched[key] = true
        }
        if (Object.keys(matched).length == Object.keys(query).length) {
            this.splice(i, 1)
        }
    }
    return result
}

Array.prototype.sum = function(field, fix) {
    let result = 0;
    for (let item of this) {
        let value = item;
        if (field && field.includes('.')) {
            let keys = field.split('.');
            for (let key of keys) {
                if (value === null) break;
                value = value[key];
            }
        } else {
            value = item[field];
        }
        if (fix) {
            result += NumberFix(value, fix);
        } else {
            result += Number(value) || 0;
        }
    }
    if (fix) {
        result = NumberFix(result, fix);
    }
    return result;
}

Array.prototype.lastIndexOf = function(query) {
    for (let i = this.length - 1; i >= 0; i--) {
        let item = this[i]
        let matched = {}
        for (let key of Object.keys(query)) {
            let r = checkKeyValue(query[key], item, item, key)
            if (r) matched[key] = true
        }
        if (Object.keys(matched).length === Object.keys(query).length) {
            return i
        }
    }
    return -1
}

const NumberFix = function(value, fix) {
    if (!value) {
        return 0
    }
    let num = Number(value)
    if (isNaN(num)) {
        return 0
    }
    if (!fix) {
        return num
    }
    let roundNum = Math.pow(100, fix / 2)
    num = Math.round(num * roundNum)
    // num = parseFloat(num / roundNum).toFixed(fix)
    num = String(num / roundNum).replace(/(\.\d{fix})\d+$/, '$1')
    return Number(num)
}

// 数组对象去重
Array.prototype.unique = function(query) {
    const res = new Map()
    return this.filter((item) => !res.has(item[query]) && res.set(item[query], 1))
}

// 对象选部分值
Vue.prototype.simple = function(origin, fields) {
    if (!origin || !fields) return origin
    if (origin instanceof Array) {
        return this.simpleArray(origin, fields)
    } else if (typeof origin == 'object') {
        return this.simpleObject(origin, fields)
    } else {
        return origin
    }
}

Vue.prototype.simpleArray = function(originArray, fields) {
    let newArray = []
    for (let item of originArray) {
        let newItem = this.simpleObject(item, fields)
        newArray.push(newItem)
    }
    return newArray
}

// 对象选部分值
Vue.prototype.simpleObject = function(origin, fields) {
    if (Object.values(fields).every((v) => v === 0)) {
        let newfields = {}
        for (let key of Object.keys(fields)) {
            newfields[key] = 1
        }
        return Vue.prototype.clearObject(origin, newfields)
    }
    let newObject = {}
    for (let field of Object.keys(fields)) {
        if (origin[field] !== undefined) {
            newObject[field] = origin[field]
            continue
        }
        let key = field.split('.')
        if (key.length == 1) {
            if (fields[field] === 1) {
                if (origin[key[0]] !== undefined) {
                    newObject[key[0]] = origin[key[0]]
                }
            } else if (fields[field] !== undefined && fields[field] !== 0) {
                newObject[key[0]] = fields[field]
            }
        } else {
            for (let i = 0; i < key.length; i++) {
                if (i < key.length - 1) {
                    let o = newObject
                    let v = origin
                    for (let j = 0; j < i; j++) {
                        o = o[key[j]]
                        v = v[key[j]]
                    }
                    if (v === null || (v && v[key[i]] === undefined)) {
                        continue
                    }
                    if (v && v[key[i]] === null) {
                        o[key[i]] = null
                        continue
                    }
                    if (o && o[key[i]] === undefined) {
                        if (v && v[key[i]] instanceof Array) {
                            o[key[i]] = []
                            for (let j = 0; j < v[key[i]].length; j++) {
                                o[key[i]].push({})
                            }
                        } else {
                            o[key[i]] = {}
                        }
                    }
                } else {
                    let o = newObject
                    let v = origin
                    for (let j = 0; j < i; j++) {
                        o = o[key[j]]
                        v = v[key[j]]
                        if (v === undefined || v === null) {
                            v = {}
                            break
                        }
                    }

                    if (fields[field] === 1) {
                        if (v && v instanceof Array) {
                            for (let j = 0; j < v.length; j++) {
                                o[j][key[i]] = v[j][key[i]]
                            }
                        } else if (v && v[key[i]] !== undefined) {
                            o[key[i]] = v[key[i]]
                        }
                    } else if (fields[field] !== undefined && fields[field] !== 0) {
                        if (v && v instanceof Array) {
                            for (let j = 0; j < v.length; j++) {
                                o[j][key[i]] = fields[field]
                            }
                        } else if (v && v[key[i]] !== undefined) {
                            o[key[i]] = fields[field]
                        }
                    }
                }
            }
        }
    }
    return newObject
}

Vue.prototype.clear = function(origin, fields) {
    if (origin instanceof Array) {
        return Vue.prototype.clearArray(origin, fields)
    } else if (typeof origin == 'object') {
        return Vue.prototype.clearObject(origin, fields)
    } else {
        return origin
    }
}

Vue.prototype.clearObject = function(origin, fields) {
    let newObject = { ...origin }
    for (let field of Object.keys(fields)) {
        let key = field.split('.')
        if (key.length == 1) {
            delete newObject[key[0]]
        } else {
            for (let i = 0; i < key.length; i++) {
                if (i < key.length - 1) {
                    let o = newObject
                    for (let j = 0; j < i; j++) {
                        o = o[key[j]]
                    }
                    if (!o[key[i]]) {
                        continue
                    }
                } else {
                    let o = newObject
                    let v = origin
                    for (let j = 0; j < i; j++) {
                        o = o[key[j]]
                        v = v[key[j]]
                        if (!v) {
                            continue
                        }
                    }
                    delete o[key[i]]
                }
            }
        }
    }
    return newObject
}

Vue.prototype.clearArray = function(originArray, fields) {
    let newArray = []
    for (let item of originArray) {
        let newItem = Vue.prototype.clearObject(item, fields)
        newArray.push(newItem)
    }
    return newArray
}

Vue.prototype.copy = function(obj) {
    return clone(obj)
}

function clone(obj) {
    // Handle the 3 simple types, and null or undefined
    if (null === obj || 'object' != typeof obj) return obj

    // Handle Date
    if (obj instanceof Date) {
        let copy1 = new Date()
        copy1.setTime(obj.getTime())
        return copy1
    }

    // Handle Array
    if (obj instanceof Array) {
        var copy2 = []
        for (var i = 0, len = obj.length; i < len; ++i) {
            copy2[i] = clone(obj[i])
        }
        return copy2
    }

    // Handle Object
    if (obj instanceof Object) {
        var copy3 = {}
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy3[attr] = clone(obj[attr])
        }
        return copy3
    }

    throw new Error("Unable to copy obj! Its type isn't supported.")
}

// 确认弹窗
Vue.prototype.showSuccessModal = function(data = {}) {
    let title = data.title || ''
    let okText = data.okText || '知道了'
    let success = data.success
    this.$Modal.success({
        title,
        okText,
        render: (h) => {
            return h('div', renderText(h, data.content, this))
        },
        onOk: () => {
            success()
        },
    })
}

// 获取render函数
function renderText(h, content, _self) {
    let renderArr = []
    for (const i of content) {
        renderArr.push(
            h('div', [
                h('span', {
                    domProps: { innerHTML: i.content || '' },
                }),
                h('a', {
                    domProps: { innerHTML: i.linkText === undefined ? '点击查看' : '' },
                    on: {
                        click: () => {
                            _self.$Modal.remove()
                            if (i.linkCallback) {
                                i.linkCallback()
                            } else {
                                window.location.hash = i.path // 适用window才能触发onhashchange事件
                            }
                        },
                    },
                }),
            ]),
        )
    }
    return renderArr
}

import VueSocketio from 'vue-socket.io'
import { SOCKET_PATH } from './ws'
// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'development1') {
    Vue.use(VueSocketio, SOCKET_PATH)
} else {
    // eslint-disable-next-line no-undef
    console.log('SOCKET OFF @ ', process.env.NODE_ENV)
}

/* eslint-disable no-new */
let vue = new Vue({
    el: '#app',
    router,
    store,
    template: '<App ref="app"/>',
    components: {
        App,
    },
})


// WEBPACK FOOTER //
// ./src/main.js